import React, { Component, ReactNode } from 'react';
import './Meter.scss';
import Alert from 'react-bootstrap/Alert';
import { CredibilityMeterScale } from './CredibilityMeterScale';
import Button from 'react-bootstrap/Button';
import { TensionMeterScale } from './TensionMeterScale';
import { MeasurementTypeEnum } from '../../api/types';
import { connect } from 'react-redux';
import { ApplicationState } from '../../app/store';
import { IDossierV2 } from '../../models/DossierV2';
import { DossierMemberInterface } from '../../models/DossierMember';

interface MeterProps {
  dossier?: IDossierV2;
  dossierRelation?: DossierMemberInterface;
  question?: string;
  type: MeasurementTypeEnum;
  start: number;
  end: number;
  onSubmit?: (value: number) => void;
  className?: string;
}

interface MeterState {
  selected: number;
  submitError?: string;
}

class Meter extends Component<MeterProps, MeterState> {
  state = {
    selected: -1,
    submitError: undefined,
  };

  handleChange = (value: number): void => {
    this.setState({ selected: value, submitError: undefined });
  };

  handleSubmit = (): void => {
    const { type } = this.props;
    const { selected } = this.state;
    if (selected !== -1) {
      if (this.props.onSubmit) {
        this.props.onSubmit(selected);
      }
    } else {
      switch (type) {
        case MeasurementTypeEnum.CREDIBILITY:
          this.setState({ submitError: 'Je hebt nog geen geloofwaardigheid geselecteerd' });
          break;
        case MeasurementTypeEnum.TENSION:
          this.setState({ submitError: 'Je hebt nog geen spanning geselecteerd' });
          break;
        default:
          this.setState({ submitError: 'Een onverwachte fout heeft zich voorgedaan' });
          throw new Error('Unexpended measurement type while handling submit');
      }
    }
  };

  private renderScale(): ReactNode {
    const { type, start, end } = this.props;
    switch (type) {
      case MeasurementTypeEnum.CREDIBILITY:
        return <CredibilityMeterScale className="meter__scale" start={start} end={end} onChange={this.handleChange} />;
      case MeasurementTypeEnum.TENSION:
        return <TensionMeterScale className="meter__scale" start={start} end={end} onChange={this.handleChange} />;
      default:
        throw new Error('Unexpended measurement type while rendering scale');
    }
  }

  public static getQuestionInfoLine(type: MeasurementTypeEnum): string {
    switch (type) {
      case MeasurementTypeEnum.TENSION:
        return 'Hoeveel spanning geeft de volgende uitspraak:';
      case MeasurementTypeEnum.CREDIBILITY:
      default:
        return 'Hoe geloofwaardig vind jij de volgende uitspraak:';
    }
  }

  private getFallbackQuestionInfoLine(): string | undefined {
    const { type } = this.props;
    switch (type) {
      case MeasurementTypeEnum.TENSION:
        return 'Hoe gespannen ben jij nu?';
      default:
        return undefined;
    }
  }

  private getInfoSection(): ReactNode {
    const { question } = this.props;
    const fallback = this.getFallbackQuestionInfoLine();
    return (<>
      {
        question &&
        <Alert className={`meter__question-container ${this.props.type === MeasurementTypeEnum.TENSION ? 'meter__question-container--tension' : 'meter__question-container--credibility'}`} variant="info">
          <div className="meter__info">{Meter.getQuestionInfoLine(this.props.type)}</div>
          <div className="meter__question">&quot;{question}&quot;</div>
        </Alert>
      }
      {
        (!question && fallback) &&
        <Alert className="meter__question-container" variant="info">{this.getFallbackQuestionInfoLine()}</Alert>
      }
    </>);
  }

  render(): ReactNode {
    const { className, dossier } = this.props;
    const { submitError } = this.state;
    const fullClassName = `meter ${className ? className : ''}`;
    return (
      <div className={fullClassName}>
        { this.getInfoSection()}
        { this.renderScale()}
        { submitError && <Alert variant="danger">{submitError}</Alert>}
        {
          !dossier?.archived &&
          <Button className="meter__submit" onClick={this.handleSubmit}>
            Verstuur
          </Button>
        }
      </div>
    );
  }
}

export default connect((state: ApplicationState) => ({
  dossier: state.session.dossier,
  dossierRelation: state.session.relation,
}))(Meter);
